import React, { useCallback, useEffect, useState } from "react";
import { Alert } from "reactstrap";

type GetWeatherInfoProps = {
  temp?: number | string;
  city?: string;
  country?: string;
  humidity?: number | string;
  description?: string;
  error?: string;
};

function GetWeatherInfo({
  temp,
  city,
  country,
  humidity,
  description,
  error
}: GetWeatherInfoProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (error) {
      setVisible(true);
    }
  }, [error]);

  const onDismiss = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <div>
      {city && country && (
        <p className=" border-bottom font-weight-medium mt-5 mb-3">
          <span className="fa fa-map-marker-alt font-color-1" /> Location :{" "}
          {city},{country}
        </p>
      )}
      {temp !== undefined && temp !== "" && (
        <p className=" border-bottom font-weight-medium mb-3">
          <span className="fa fa-temperature-high font-color-1" /> Temperature:{" "}
          {temp}
        </p>
      )}
      {humidity !== undefined && humidity !== "" && (
        <p className=" border-bottom font-weight-medium mb-3">
          <span className="fa fa-water font-color-1" /> Humidity: {humidity}
        </p>
      )}
      {description && (
        <p className=" border-bottom font-weight-medium mb-3">
          <span className="fa fa-umbrella font-color-1" /> Conditions:{" "}
          {description}
        </p>
      )}
      {error && (
        <Alert
          className="mt-2"
          color="danger"
          isOpen={visible}
          toggle={onDismiss}
        >
          {error}
        </Alert>
      )}
    </div>
  );
}

export default GetWeatherInfo;
